import router from '@/router';
import * as Sentry from '@sentry/vue';
import { Vue } from '@sentry/vue/build/types/types';
import { getEnvVar } from '@/utils/env';

const initialize = (app: Vue) => {
  const tracesSampleRate = parseFloat(getEnvVar('VITE_SENTRY_TRACES_SAMPLE_RATE') ?? '0.0');

  if (tracesSampleRate) {
    const __APP_BUILD__ = '0.1';
    const release: string = __APP_BUILD__;
    const environment = getEnvVar('VITE_SENTRY_ENVIRONMENT');
    const dsn = getEnvVar('VITE_SENTRY_DSN');
    const tracingDomain = getEnvVar('VITE_SENTRY_BASEURL').split('.').join('\\.');

    Sentry.init({
      app,
      dsn: dsn,
      environment,
      release,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: tracesSampleRate,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [new RegExp(`^https://${tracingDomain}/`)],

      // Capture Replay for 0% of all sessions,
      // plus for 0% of sessions with an error
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 0.0,

      // ignore errors from Hybris javascript -> /themes-acv/customize.js
      denyUrls: [/https?:\/\/((vacations)(-qasup|-qa|-uat)?\.)?aircanada\.com\/_ui\/responsive\/common\/js/]
    });
  }
};

const sentryConfig = () => {
  return {
    initialize
  };
};

export default sentryConfig;
